import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Spin, Result } from 'antd';
import clienteAxios from '../Utils/clienteAxios';
import setToken from '../Utils/setToken';
import decodeToken from '../Utils/decodeToken';
import Boton from '../Components/Atoms/Boton';

/**
 * Entrada desde la intranet.
 *
 * La intranet manda aquí con un ticket firmado en la query. Esta pantalla lo
 * cambia por el JWT de BPMS y continúa como cualquier sesión: el resto de la
 * aplicación no distingue si el token vino de aquí o del formulario de login.
 *
 * No decide quién entra —eso lo resuelve el backend, que solo acepta correos
 * con cuenta ya existente—; únicamente muestra el motivo cuando el acceso se
 * rechaza.
 */
const SsoIntranet = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  // El ticket se canjea una sola vez: el backend lo invalida al usarlo. Sin
  // esta guarda, un segundo montaje del efecto (StrictMode, un re-render
  // inesperado) gastaría el ticket y el usuario vería "ya se utilizó" sobre un
  // acceso que en realidad era válido.
  const canjeIniciado = useRef(false);

  useEffect(() => {
    if (canjeIniciado.current) return;
    canjeIniciado.current = true;

    const ticket = searchParams.get('ticket');

    if (!ticket) {
      setError('El enlace de acceso está incompleto. Vuelve a entrar desde la intranet.');
      return;
    }

    clienteAxios
      .post('/sso/intranet', { ticket })
      .then((response) => {
        const token = response.data.access_token;
        localStorage.setItem('token', token);
        setToken(token);

        const decoded = decodeToken(token);
        // replace: el ticket queda en la URL y ya está consumido. Sin replace,
        // el botón "atrás" regresaría a un canje que forzosamente fallaría.
        navigate('/inicio', { replace: true, state: { bienvenida: decoded?.user?.name } });
      })
      .catch((err) => {
        setError(
          err.response?.data?.message ||
            err.response?.data?.msg ||
            'No fue posible iniciar tu sesión desde la intranet. Intenta de nuevo.'
        );
      });
  }, [searchParams, navigate]);

  if (error) {
    return (
      <Result
        status="warning"
        title="No pudimos iniciar tu sesión"
        subTitle={error}
        extra={
          <Boton type="primary" onClick={() => navigate('/login', { replace: true })}>
            IR AL INICIO DE SESIÓN
          </Boton>
        }
      />
    );
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '1rem'
      }}>
      <Spin size="large" />
      <span>Validando tu acceso desde la intranet…</span>
    </div>
  );
};

export default SsoIntranet;
